import NewBooking from "./NewBooking";

const VrBookings = () => {
  return (
    <NewBooking
      title="VR foglalás"
      question="Hány VR helyet szeretnél foglalni?"
      description="Válaszd ki, hány VR helyet szeretnél foglalni a csapatod számára."
      availableItems="availableVr"
      serviceType="vr"
      durationMinutes="vrSlotDurationMinutes"
      intervalMinutes="vrSlotIntervalMinutes"
    />
  );
};

export default VrBookings;
